// @flow
// easing equations from https://github.com/danro/easing-js/blob/master/easing.js
const easingEquationFunc = {
    easeOutSine: (pos: number): number => {
        return Math.sin(pos * (Math.PI / 2));
    },
    easeInOutSine: (pos: number): number => {
        return -0.5 * (Math.cos(Math.PI * pos) - 1);
    },
    easeInOutQuint: (pos: number): number => {
        let halfPos = pos / 0.5;
        if (halfPos < 1) {
            return 0.5 * Math.pow(halfPos, 5);
        }
        return 0.5 * (Math.pow(halfPos - 2, 5) + 2);
    }
};

export type easingEquations =
    | 'easeOutSine'
    | 'easeInOutSine'
    | 'easeInOutQuint';

export const scrollToAnimated = (
    scrollTargetY: number = 0,
    speed: number = 2000,
    easing: easingEquations = 'easeOutSine',
    callback?: () => mixed
): void => {
    // scrollTargetY: the target scrollY property of the window
    // speed: time in pixels per second
    // easing: easing equation to use
    if (typeof window === 'undefined') {
        return;
    }
    let scrollY: number =
        window.scrollY ||
        (document &&
            document.documentElement &&
            document.documentElement.scrollTop) ||
        0;
    let currentTime = 0;

    // min time .1, max time .8 seconds
    let time = Math.max(
        0.1,
        Math.min(Math.abs(scrollY - scrollTargetY) / speed, 0.8)
    );

    // add animation loop
    const tick = () => {
        currentTime += 1 / 60;

        let p = currentTime / time;
        let t = easingEquationFunc[easing](p);

        if (p < 1) {
            requestAnimationFrame(tick);

            window.scrollTo(0, scrollY + (scrollTargetY - scrollY) * t);
        } else {
            window.scrollTo(0, scrollTargetY);
            if (callback) {
                callback();
            }
        }
    };

    // call it once to get started
    tick();
};

export const scrollToTop = (): void => {
    if (typeof window === 'undefined') {
        return;
    }
    window.scrollTo(0, 0);
};
